/* transform hover:scale-105 */
.qumra-cart-button{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 45px;
  border-radius: 99999999px;
}

.qumra-cart-badge {
  position: absolute;
  top: 0px;
  right: 0px;
  display: inline-flex;
  justify-content: center;
  border-radius: 9999px;
  font-size: .75rem;
  line-height: 1rem;
  color: #fff;
}
.qumra-cart-content{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
